import * as React from 'react'
import type {SyntheticEvent} from 'react'

import CommonPopup from '../../../components/CommonPopup/CommonPopup'
import EditAgentPoolForm from '../../../components/EditAgentPoolForm/EditAgentPoolForm'
import type {AgentPool} from '../../AgentPoolPage.types'

type Props = {
  agentPool: AgentPool
  onUpdate: () => void
  onRemove: () => void
  onClose: () => void
  hidden: boolean
}

export default function EditAgentPoolPopup({
  agentPool,
  onUpdate,
  onRemove,
  onClose,
  hidden,
}: Props): React.ReactElement {
  const handleClose = React.useCallback(
    (e?: Event | SyntheticEvent) => {
      if (e?.target instanceof HTMLElement && e.target.closest('[role="dialog"]') == null) {
        onClose()
      }
    },
    [onClose],
  )
  return (
    <CommonPopup
      top={4}
      hidden={hidden}
      onClose={handleClose}
      header={'Edit Agent Pool'}
      content={
        <EditAgentPoolForm
          agentPool={agentPool}
          onUpdate={onUpdate}
          onClose={onClose}
          onRemove={onRemove}
        />
      }
    />
  )
}
